/* eslint-disable react-hooks/rules-of-hooks */
import { useSelector } from "react-redux";

export const metaData = (state) => state.metadata && state.metadata.data;
export const links = (state) => state.metadata && state.metadata.links;

export const withLinks = () => useSelector(links);
export const withMetaData = () => useSelector(metaData);
